module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "tree",
    staticClass: "rt-tree"
  }, [_c('div', {
    staticClass: "rt-tree-header",
    class: {
      'has-add-button': _vm.showAdd || _vm.$slots.addButton
    }
  }, [(_vm.search) ? _c('rt-search', {
    attrs: {
      "more": false,
      "placeholder": _vm.searchPlaceholder
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAdd || _vm.$slots.addButton) ? _vm._t("addButton", function() {
    return [_c('rt-button', {
      attrs: {
        "icon-name": "rt-base-plus",
        "color-type": "info",
        "type": "plain"
      },
      on: {
        "click": _vm.addClickHandler
      }
    })]
  }) : _vm._e()], 2), _vm._v(" "), _c('el-tree', {
    ref: "elTree",
    attrs: {
      "data": _vm.dataSource,
      "node-key": _vm.nodeKey,
      "empty-text": _vm.emptyText,
      "props": _vm.props,
      "show-checkbox": _vm.showCheckbox,
      "default-expand-all": _vm.defaultExpandAll,
      "expand-on-click-node": _vm.expandOnClickNode,
      "check-on-click-node": _vm.checkOnClickNode,
      "default-checked-keys": _vm.defaultCheckedKeys,
      "default-expanded-keys": _vm.defaultExpandedKeys,
      "draggable": _vm.draggable,
      "allow-drag": _vm.allowDrag,
      "allow-drop": _vm.allowDrop,
      "accordion": _vm.accordion,
      "filter-node-method": _vm.filterNode
    },
    on: {
      "node-click": _vm.nodeClick,
      "check": _vm.check,
      "check-change": _vm.checkChange,
      "node-expand": _vm.nodeExpand,
      "node-collapse": _vm.nodeCollapse,
      "node-drag-start": _vm.nodeDragStart,
      "node-drag-enter": _vm.nodeDragEnter,
      "node-drag-leave": _vm.nodeDragLeave,
      "node-drag-over": _vm.nodeDragOver,
      "node-drag-end": _vm.nodeDragEnd,
      "node-drop": _vm.nodeDrop
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          staticClass: "rt-tree-node",
          class: {
            'has-leaf-avatar': data.avatar !== false && node.isLeaf && _vm.leafAvatar
          }
        }, [_c('span', {
          staticClass: "rt-tree-node-left"
        }, [(data.avatar !== false && node.isLeaf && _vm.leafAvatar) ? _c('rt-avatar', {
          attrs: {
            "src": data.avatarSrc,
            "size": "small",
            "type": "info",
            "effect": "light"
          }
        }, [_vm._v(_vm._s(node.label.charAt(0)))]) : _vm._t("icon", function() {
          return [(data.rtIconName || _vm.rtIconName) ? _c('rt-icon', {
            attrs: {
              "name": data.rtIconName || _vm.rtIconName,
              "size": node.isLeaf ?
                data.rtLeafIconSize || _vm.rtLeafIconSize :
                data.rtIconSize || _vm.rtIconSize,
              "color": data.rtIconColor || _vm.rtIconColor
            }
          }) : _vm._e()]
        }, {
          "node": node,
          "data": data
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(node.label))]), _vm._v(" "), (_vm.rtTag !== false && data.rtTag) ? _c('rt-tag', {
          attrs: {
            "border": "",
            "size": "small",
            "color-type": "primary"
          }
        }, [_vm._v(_vm._s(data[data.rtTag || _vm.rtTag] || data['rtTag']))]) : _vm._e(), _vm._v(" "), _vm._t("node-right", null, {
          "node": node,
          "data": data
        })], 2), _vm._v(" "), _c('span', {
          staticClass: "rt-tree-node-right"
        }, [_vm._t("default", null, {
          "node": node,
          "data": data
        })], 2)])
      }
    }, {
      key: "node-desc",
      fn: function(scope) {
        return [_vm._t("node-desc", null, {
          "node": scope.node
        })]
      }
    }], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c7e2713"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tree/rtTree.vue
// module id = 2028
// module chunks = 228